import FleetManagementRow from './FleetManagementRow';

// eslint-disable-next-line import/prefer-default-export
export { FleetManagementRow };
